import { createStoreId } from '@/stores/createStoreId';
import { useSnackbar } from '@aleph-alpha/ds-components-vue';
import { defineStore } from 'pinia';

export const useSnackbarStore = defineStore(createStoreId('snackbarStore'), useSnackbar);
